import React from 'react';
import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@fluentui/react-components';
import { ErrorCircle24Regular, Dismiss20Regular } from '@fluentui/react-icons';
import './drag-drop/UploadErrorDialog.css';

interface ErrorDialogProps {
    isOpen: boolean;
    onDismiss: () => void;
    title?: string;
    message: string;
    details?: string;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
    isOpen,
    onDismiss,
    title = "Error",
    message,
    details
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={(e, data) => !data.open && onDismiss()}>
            <DialogSurface className="upload-error-dialog">
                <DialogBody>
                    <DialogTitle className="upload-error-title">
                        <ErrorCircle24Regular className="error-icon" />
                        {title}
                    </DialogTitle>
                    <Dismiss20Regular 
                        className="dismiss-icon" 
                        onClick={onDismiss} 
                        data-testid="error-dialog-dismiss"
                    />
                    <DialogContent className="upload-error-content">
                        <div className="error-message">
                            {message}
                        </div>
                        {details && (
                            <div className="error-details">
                                <strong>Details:</strong>
                                <div className="details-text">{details}</div>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            appearance="primary" 
                            onClick={onDismiss}
                            data-testid="error-dialog-ok"
                        >
                            OK
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
